import api from "@/api/url";

export default {
    namespaced: true,
    state: () => {
        return {
            reportFilter: {
                type: "clients",
                fieldType: "clients",
                year: String(new Date().getFullYear()),
            },
            reportData: {
                clients: undefined,
                projects: undefined,
                invoices: undefined,
            },
            recentClients: [],
            recentProjects: [],
        };
    },

    getters: {
        reportFilter: state => state.reportFilter,
        reportData: state => state.reportData,
        recentClients: (state) => state.recentClients,
        recentProjects: state => state.recentProjects,
    },

    mutations: {
        set(state, [key, value]) {
            state[key] = value;
        },
    },
    
    actions: {
        fetchReports({ commit, state }, { payload, refresh = false }) {            
            const type = payload?.fieldType;

            if (state.reportData[type] && !refresh) return; // to avoid making unnecessary calls

            return api.user.getReports(payload)
                .then((res) => {
                    const data = res.data.data;
                    const firstItem = data.length ? data[0] : {};

                    commit("set", ["reportData", {
                        ...state.reportData,
                        [type]: firstItem,
                    }]);

                    return state.reportData[type] || {};
                });
        },

        downloadReports(_, { config, payload }) {            
            return api.user.downloadReports(payload, config)
                .then((res) => {
                    return res?.data;
                });
        },

        setReportFilter({ commit, state }, payload) {
            const reportData = JSON.parse(localStorage.getItem("z_report_filter"));
            commit("set", ["reportFilter", {
                ...state.reportFilter,
                ...payload,
                type: payload?.fieldType || payload?.type,
            }]);
            localStorage.setItem("z_report_filter", JSON.stringify({ ...reportData, ...payload, type: payload?.fieldType }));
        },

        fetchMostRecentClients({ commit, state }, { params, refresh }) {
            if (!refresh && state.recentClients.length) return;

            return api.client.fetchMostRecent(params)
                .then((resp) => {
                    const data = resp?.data?.data;
                    commit("set", ["recentClients", data]);
                });
        },

        fetchMostRecentProjects({ commit, state }, { params, refresh }) {
            if (!refresh && state.recentProjects.length) return;

            return api.project.fetchMostRecent(params)
                .then((resp) => {
                    const data = resp?.data?.data;
                    commit("set", ["recentProjects", data]);
                });
        },
    },
};